/*
 * Copyright (c) 2019 - Indigen Solutions
 * Authors:
 *   - Bichoy Messiha <bm@indigen.com>
 * NOTICE: All information contained herein is, and remains
 * the property of Indigen Solutions and its suppliers,
 * if any.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */
import { nanoid } from "nanoid";
import { isEmpty } from "lodash";
class ConventionManager {
    isParentEnveloppe(convention) {
        return (
            convention.parentType === "enveloppe" &&
            convention.childrenConventions &&
            convention.childrenConventions.length > 0
        );
    }

    generateTitleIdsForConvention(convention) {
        const caMeta = {
            ...convention.caMeta,
            heading: convention?.caMeta?.heading
                ? this.generateTitleIds(convention.caMeta.heading)
                : null,
            annex: convention?.caMeta?.annex
                ? this.generateTitleIds(convention.caMeta.annex)
                : null,
        };
        const territories = this.generateTitleIdsForItemGroups(convention.territories);
        const activities = this.generateTitleIdsForItemGroups(convention.activities);
        const excludedActivities = this.generateTitleIdsForItemGroups(
            convention.excludedActivities
        );
        return { ...convention, caMeta, territories, activities, excludedActivities };
    }

    generateTitleIdsForItemGroups(itemGroups) {
        return itemGroups.map(itemGroup => {
            if (itemGroup.type !== "text") return itemGroup;
            return {
                ...itemGroup,
                body: this.generateTitleIds(itemGroup.body),
            };
        });
    }

    generateTitleIds(rawHtml, availableHeadings = ["h1", "h2", "h3", "h4", "h5", "h6"]) {
        const $container = document.createElement("div");
        $container.innerHTML = rawHtml;
        availableHeadings.forEach(availableHeading => {
            $container.querySelectorAll(availableHeading).forEach($h => {
                if (isEmpty($h.id)) {
                    $h.id = `h.${nanoid()}`;
                }
            });
        });
        return $container.innerHTML;
    }
}

const conventionManager = new ConventionManager();
export default conventionManager;
